// extracted by extract-css-chunks-webpack-plugin
module.exports = {"product-pane":"dlFMF","sticky":"vWhyz","medalia-div":"msI5o"};